package dairy.mynotes.reusablecomponents

import androidx.compose.runtime.Composable
import dairy.mynotes.ui.theme.AppColors

@Composable
fun TextButtonComponent(
    text: String,
    modifier: androidx.compose.ui.Modifier = androidx.compose.ui.Modifier,
    textColor: androidx.compose.ui.graphics.Color = AppColors.PrimaryVariant,
    onClick: () -> Unit,
) {
    androidx.compose.material3.TextButton(
        onClick = onClick,
        modifier = modifier
    ) {
        Label(
            text = text,
            color = textColor,
            textStyle = androidx.compose.material3.MaterialTheme.typography.titleMedium,
                    modifier = modifier
        )
    }
}